import React, { useState } from "react";
import { initials, stringToColor } from "@/lib/format";

export function UserAvatar({ user, size = 28, className = "" }) {
    const [broken, setBroken] = useState(false);
    const showImg = user?.avatar_url && !broken;
    const label = initials(user?.first_name, user?.last_name);
    const bg = stringToColor(user?.email || label);
    const style = { width: size, height: size, background: showImg ? undefined : bg, fontSize: size * 0.42 };
    return (
        <div
            title={`${user?.first_name || ""} ${user?.last_name || ""}`.trim()}
            className={`rounded-full inline-flex items-center justify-center text-white font-semibold border border-white shadow-sm overflow-hidden ${className}`}
            style={style}
            data-testid="user-avatar"
        >
            {showImg ? (
                <img src={`${process.env.REACT_APP_BACKEND_URL}${user.avatar_url}`} alt="" onError={() => setBroken(true)} onLoad={(e) => { if (e.currentTarget.naturalWidth <= 1) setBroken(true); }} className="w-full h-full object-cover" />
            ) : (
                <span>{label}</span>
            )}
        </div>
    );
}
